import React from 'react';
import Helmet from 'react-helmet';

import Header from '../components/Header';
import Footer from '../components/Footer';

import './index.scss';

const TemplateWrapper = ({ children, layoutContext }) => (
  <div className="main-layout">
    <Helmet
      title={layoutContext.content.title}
      meta={[
        { name: 'description', content: layoutContext.content.metaDescription },
        { name: 'keywords', content: layoutContext.content.metaKeywords },
        {
          name: 'google-site-verification',
          content: 'KJXLJ26eu4zIT4ArcLlASc18Gumz5UJxQy1vcg-pn5A',
        },
      ]}
    >
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    </Helmet>
    <Header
      layoutContext={layoutContext}
      languages={layoutContext.languages}
      phone={layoutContext.content.headerPhone}
    />
    {children()}
    <Footer layoutContext={layoutContext} />
  </div>
);

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/mainLayout.jsx